import { BREAKPOINTS } from 'styles/breakpoints';
import type { PinLimitConfig } from 'domain/map-pin/map-pin.types';

/**
 * Viewport-based pin limits, ordered from largest to smallest breakpoint.
 * The first matching entry (where viewport width >= minWidth) is used.
 */
export const MAP_PIN_LIMITS: readonly PinLimitConfig[] = [
  { minWidth: BREAKPOINTS.XL_DESKTOP, maxPins: 600, fullPinThreshold: 150 },
  { minWidth: BREAKPOINTS.LARGE_DESKTOP, maxPins: 400, fullPinThreshold: 100 },
  { minWidth: BREAKPOINTS.MOBILE, maxPins: 200, fullPinThreshold: 50 },
  { minWidth: 0, maxPins: 80, fullPinThreshold: 30 },
] as const;

export const DEFAULT_PIN_LIMITS: PinLimitConfig = MAP_PIN_LIMITS[MAP_PIN_LIMITS.length - 1];
